import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-in-delivery-zone',
  imports: [],
  templateUrl: './in-delivery-zone.component.html',
  styleUrl: './in-delivery-zone.component.scss'
})
export class InDeliveryZoneComponent {
  activeModal = inject(NgbActiveModal);

  signUp() {
    this.activeModal.close({ confirm: true });
  }

  returnToStore() {
    this.activeModal.close({ confirm: false });
  }
}
